import { render, staticRenderFns } from "./ModalInviteUserAndSetRole.vue?vue&type=template&id=5eecc362&scoped=true"
import script from "./ModalInviteUserAndSetRole.vue?vue&type=script&lang=js"
export * from "./ModalInviteUserAndSetRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eecc362",
  null
  
)

export default component.exports